import { createRoot } from 'react-dom/client'
import { App } from './src'

const root = createRoot(document.getElementById('root')!)
root.render(<App key={'pos-hub-apps'} />)
